module.exports = __webpack_public_path__ + "img/mind_template_item_4_1.f6aec01f.png";